// 2_components/footer_heureka_reviews.js
// Downloads Heureka (CZ/SK) / Ceneo (PL) shop reviews from GitHub with a 24h
// localStorage cache, renders the viable ones into the footer and initializes
// the reviews slider once the "downloadAndSaveHeurekaReviews" event fires.

export function init() {
	if (!window.NAT?.utils?.inicializeSliderElement) {
		console.warn("[NAT] footer_heureka_reviews.js: window.NAT.utils.inicializeSliderElement missing — check load order");
		return;
	}

	document.addEventListener("downloadAndSaveHeurekaReviews", onHeurekaReviewsReady);
	document.addEventListener("emptyCartFooterInjected", () => {
		footer = document.querySelector("#footer");
		downloadAndSaveHeurekaReviews();
	});

	document.addEventListener("DOMContentLoaded", async function () {
		footer = document.querySelector("#footer");
		if (!footer) {
			return;
		}
		downloadAndSaveHeurekaReviews();
	});
}

function onHeurekaReviewsReady() {
	footer = document.querySelector("#footer");
	if (!footer) {
		return;
	}
	insertHeurekaReviews();
	const heurekaWrapper = footer.querySelector(".heureka-reviews-wrapper");
	const heurekaParent = footer.querySelector("#heureka-reviews-insert");
	const heurekaReviews = footer.querySelectorAll(".heureka-review");
	if (!heurekaWrapper || !heurekaParent || !heurekaReviews.length) return;
	window.NAT.utils.inicializeSliderElement(heurekaWrapper, heurekaParent, heurekaReviews, "heureka-slider", null);
}

let footer;
let heurekaReviewsData;
// NOTE: incremented while rendering but never read anywhere (same as the old code).
let numberOfTotalViableReviews = 0;

async function insertHeurekaReviews() {
	if (!footer) {
		return;
	}
	const heurekaInsertElement = footer.querySelector("#heureka-reviews-insert");
	if (!heurekaInsertElement) {
		console.warn("Heureka reviews insert element not found.");
		return;
	}
	if (heurekaInsertElement.querySelector(".heureka-review")) {
		return;
	}
	if (!heurekaReviewsData || heurekaReviewsData.length === 0) {
		console.warn("No Heureka reviews data available.");
		return;
	}

	heurekaReviewsData.forEach((review) => {
		const reviewElement = document.createElement("div");
		reviewElement.className = "heureka-review";
		let contentLength = 0;

		// Review stars
		const reviewRatingWrapper = document.createElement("div");
		reviewRatingWrapper.className = "heureka-review-rating-wrapper";
		if (!review.total_rating || !review.total_rating._text) {
			return;
		}
		for (let i = 0; i < review.total_rating._text; i++) {
			const starIcon = document.createElement("i");
			starIcon.className = "heureka-icon-star";
			reviewRatingWrapper.appendChild(starIcon);
		}
		reviewElement.appendChild(reviewRatingWrapper);

		// Review summary
		if (review.summary && review.summary._cdata) {
			if (review.summary._cdata.length < 100) {
				const reviewText = document.createElement("p");
				reviewText.className = "heureka-review-summary";
				reviewText.textContent = review.summary._cdata;
				reviewElement.appendChild(reviewText);
				contentLength += review.summary._cdata.length;
			}
		}

		if (window.NAT.lang === "cs" || window.NAT.lang === "sk") {
			// Review pros
			if (review.pros && review.pros._cdata) {
				let reviesEditedProData = [];
				const reviewPros = document.createElement("div");
				reviewPros.className = "heureka-review-pros";
				const prosString = review.pros._cdata; // Extract the string from _cdata
				const prosStringEdited = prosString.match(/[A-Z][^A-Z]*/g); // Split by sequences starting with a capital letter

				if (prosStringEdited && prosStringEdited.length > 0) {
					reviesEditedProData = prosStringEdited;
				} else {
					reviesEditedProData[0] = prosString;
				}

				// Return if there are more than 3 pros (likely an error)
				if (reviesEditedProData.length > 3) {
					return;
				}
				reviesEditedProData.forEach((pro) => {
					const proElement = document.createElement("span");
					proElement.className = "heureka-review-pro";
					proElement.textContent = pro.trim();
					reviewPros.appendChild(proElement);
				});
				reviewElement.appendChild(reviewPros);
				contentLength += review.pros._cdata.length * 1.5;
			}

			// Review cons
			if (review.cons && review.cons._cdata) {
				let reviewsEditedConsData = [];
				const reviewCons = document.createElement("div");
				reviewCons.className = "heureka-review-cons";
				const consString = review.cons._cdata; // Extract the string from _cdata
				const consStringEdited = consString.match(/[A-Z][^A-Z]*/g); // Split by sequences starting with a capital letter

				if (consStringEdited && consStringEdited.length > 0) {
					reviewsEditedConsData = consStringEdited;
				} else {
					reviewsEditedConsData[0] = consString;
				}

				// Return if there are more than 3 cons (likely an error)
				if (reviewsEditedConsData.length > 3) {
					return;
				}

				reviewsEditedConsData.forEach((con) => {
					const conElement = document.createElement("span");
					conElement.className = "heureka-review-con";
					conElement.textContent = con.trim();
					reviewCons.appendChild(conElement);
				});

				reviewElement.appendChild(reviewCons);
				contentLength += review.cons._cdata.length * 1.5;
			}

			// Return if content is less than 40 and more than 150
			if (contentLength < 50 || contentLength > 100) {
				return;
			}
		}
		numberOfTotalViableReviews = numberOfTotalViableReviews + 1;

		// Add to heurekaInsertElement
		heurekaInsertElement.appendChild(reviewElement);
	});
}

async function downloadAndSaveHeurekaReviews() {
	const url = window.NAT.translations("gitHeurekaReviewsUrl");
	const storageKey = "heurekaReviews";
	const expiryKey = "heurekaReviews_expiry";

	// Check if data is already in localStorage and not expired
	const now = Date.now();
	const expiry = localStorage.getItem(expiryKey);
	const cached = localStorage.getItem(storageKey);
	if (expiry && cached && now < parseInt(expiry)) {
		// Data is still valid

		heurekaReviewsData = JSON.parse(cached).reviews.review;

		console.log("Heureka reviews loaded from localStorage.");
		console.log("CUSTOM EVENT DISPATCHED: downloadAndSaveHeurekaReviews");
		document.dispatchEvent(new CustomEvent("downloadAndSaveHeurekaReviews"));
		return;
	}

	// Fetch and save
	try {
		const response = await fetch(url);
		if (!response.ok) throw new Error("Network response was not ok");
		const data = await response.json();
		localStorage.setItem(storageKey, JSON.stringify(data));
		localStorage.setItem(expiryKey, (now + 24 * 60 * 60 * 1000).toString());

		heurekaReviewsData = data.reviews.review;

		console.log("Heureka reviews saved to localStorage.");
		console.log("CUSTOM EVENT DISPATCHED: downloadAndSaveHeurekaReviews");
		document.dispatchEvent(new CustomEvent("downloadAndSaveHeurekaReviews"));
	} catch (error) {
		console.error("Failed to fetch Heureka reviews:", error);
	}
}
